import Brightness4Icon from '@mui/icons-material/Brightness4';
import Brightness7Icon from '@mui/icons-material/Brightness7';
import { IconButton, Tooltip } from '@mui/material';

import { useTranslation } from '../../i18n';
import { useColorMode } from '../../theme/ColorModeContext';

/** App-bar button that flips the whole app between light and dark mode. */
const DarkModeToggle = () => {
  const { mode, toggleColorMode } = useColorMode();
  const { t } = useTranslation();
  const isDark = mode === 'dark';

  return (
    <Tooltip title={isDark ? t('common.lightMode') : t('common.darkMode')}>
      <IconButton
        onClick={toggleColorMode}
        aria-label="Toggle color mode"
        sx={{ color: '#fff' }}
      >
        {isDark ? <Brightness7Icon /> : <Brightness4Icon />}
      </IconButton>
    </Tooltip>
  );
};

export default DarkModeToggle;
